import React from 'react';
import { X, CheckCircle, XCircle } from 'lucide-react';

const CloseAllResultsModal = ({ isOpen, onClose, results }) => {
    if (!isOpen || !results) return null;

    const { successful_orders = [], failed_orders = [] } = results.data || {};
    const hasSuccessful = successful_orders.length > 0;
    const hasFailed = failed_orders.length > 0;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-sm w-full mx-4 max-h-[80vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between p-4 border-b">
                    <h3 className="text-lg font-semibold">Close All Orders - Results</h3>
                    <button
                        onClick={onClose}
                        className="p-1 hover:bg-gray-100 rounded-full transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Content */}
                <div className="overflow-y-auto flex-1 p-4">
                    {/* Successful Orders */}
                    {hasSuccessful && (
                        <div className="mb-4">
                            <div className="flex items-center gap-2 mb-3">
                                <CheckCircle className="text-green-600" size={20} />
                                <h4 className="font-semibold text-green-700">
                                    Successful Orders ({successful_orders.length})
                                </h4>
                            </div>
                            <div className="space-y-2">
                                {successful_orders.map((order, index) => (
                                    <div
                                        key={index}
                                        className="bg-green-50 border border-green-200 rounded-lg p-3"
                                    >
                                        <div className="flex justify-between items-start mb-1">
                                            <span className="font-medium text-green-900">
                                                {order.script_name}
                                            </span>
                                            <span className="text-xs text-green-700 bg-green-100 px-2 py-1 rounded">
                                                {order.type?.toUpperCase()}
                                            </span>
                                        </div>
                                        <div className="text-sm text-green-700">
                                            <div className="flex justify-between">
                                                <span>Symbol:</span>
                                                <span className="font-medium">{order.symbol}</span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span>Qty:</span>
                                                <span className="font-medium">{order.qty}</span>
                                            </div>
                                            <div className="flex justify-between">
                                                <span>Price:</span>
                                                <span className="font-medium">₹{order.price?.toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Failed Orders */}
                    {hasFailed && (
                        <div>
                            <div className="flex items-center gap-2 mb-3">
                                <XCircle className="text-red-600" size={20} />
                                <h4 className="font-semibold text-red-700">
                                    Failed Orders ({failed_orders.length})
                                </h4>
                            </div>
                            <div className="space-y-2">
                                {failed_orders.map((order, index) => (
                                    <div
                                        key={index}
                                        className="bg-red-50 border border-red-200 rounded-lg p-3"
                                    >
                                        <div className="flex justify-between items-start mb-2">
                                            <span className="font-medium text-red-900">
                                                {order.symbol}
                                            </span>
                                            <span className="text-xs text-red-700 bg-red-100 px-2 py-1 rounded">
                                                FAILED
                                            </span>
                                        </div>
                                        <div className="text-sm text-red-700">
                                            <div className="flex items-start gap-1">
                                                <span className="font-medium">Reason:</span>
                                                <span className="flex-1">{order.reason}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* No orders message */}
                    {!hasSuccessful && !hasFailed && (
                        <div className="text-center text-gray-500 py-8">
                            No orders processed
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="border-t p-4">
                    <button
                        onClick={onClose}
                        className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors font-medium"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CloseAllResultsModal;